import { render, staticRenderFns } from "./CompetenceDetailsForm.vue?vue&type=template&id=419a46a1&"
import script from "./CompetenceDetailsForm.vue?vue&type=script&lang=js&"
export * from "./CompetenceDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports